import { useContext } from "react";
import { AdapterContext } from "./adapter-context";
import type { SignalActionsAdapter, SignalFeedAdapter } from "./types";

/** Read the active feed adapter from context (mock in Phase D). */
export function useFeedAdapter(): SignalFeedAdapter {
  return useContext(AdapterContext).feed;
}

/** Read the active actions adapter from context (mock in Phase D). */
export function useActionsAdapter(): SignalActionsAdapter {
  return useContext(AdapterContext).actions;
}
